/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 11:06 上午
*/
import {login} from "../../api/login";
import {getUserInfo} from "../../api/mine";
import {getSystemConfig} from "../../api/app";

export default {
    // 登录
    login({commit}, userInfo) {
        return new Promise((resolve, reject) => {
            login(userInfo.username, userInfo.password).then(result => {
                commit('SET_TOKEN', result.token);
                resolve(result);
            }).catch(err => {
                reject(err);
            })
        })
    },

    // 获取用户信息
    getUserInfo({commit}) {
        return new Promise((resolve, reject) => {
            getUserInfo().then(result => {
                commit('SET_USER_INFO', result);
                resolve(result);
            }).catch(err => {
                reject(err);
            })
        })
    },

    // 获取系统配置
    getSystemConfig({commit}) {
        return new Promise((resolve, reject) => {
            getSystemConfig().then(result => {
                commit('SET_PROJECT_CONFIG', result);
                resolve(result);
            }).catch(err => {
                reject(err);
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js